import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { gql } from '@apollo/client';
import { ErrorMessage } from '@infl-ts/util-io-ts';
import { makeDecodedMutation } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { Comment } from './codecs';
import { publicResponseCommentFragment, publicResponseMemberFragment } from './queries';
export var useCommentOnPublic = makeDecodedMutation(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation CommentOnPublicResponse($input: CommentOnPublicResponseInput!) {\n      commentOnPublicResponse(input: $input) {\n        ... on CommentOnPublicResponseErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n\n        ... on CommentOnPublicResponseResult {\n          result {\n            ...PublicResponseCommentFragment\n          }\n        }\n      }\n    }\n\n    ", "\n    ", "\n  "])), publicResponseMemberFragment, publicResponseCommentFragment), t.type({
  commentOnPublicResponse: t.union([t.type({
    __typename: t.literal('CommentOnPublicResponseResult'),
    result: Comment
  }), t.type({
    __typename: t.literal('CommentOnPublicResponseErrors'),
    errors: t.array(ErrorMessage)
  })])
}), t.type({
  input: t.type({
    id: t.string,
    body: t.string
  })
}));
export var useHidePublicResponse = makeDecodedMutation(gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation HidePublicResponse($id: ID!) {\n      hidePublicResponse(id: $id) {\n        ... on Error {\n          message\n        }\n        ... on ShowHidePublicResponseResult {\n          publicResponse {\n            id\n            hidden\n          }\n        }\n      }\n    }\n  "]))), t.type({
  hidePublicResponse: t.union([t.type({
    __typename: t.literal('ShowHidePublicResponseResult'),
    publicResponse: t.type({
      id: t.string,
      hidden: t["boolean"]
    })
  }), t.type({
    __typename: t.literal('Error'),
    ErrorMessage: ErrorMessage
  })])
}), t.type({
  id: t.string
}));
export var useShowPublicResponse = makeDecodedMutation(gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    mutation ShowPublicResponse($id: ID!) {\n      showPublicResponse(id: $id) {\n        ... on Error {\n          message\n        }\n        ... on ShowHidePublicResponseResult {\n          publicResponse {\n            id\n            hidden\n          }\n        }\n      }\n    }\n  "]))), t.type({
  showPublicResponse: t.union([t.type({
    __typename: t.literal('ShowHidePublicResponseResult'),
    publicResponse: t.type({
      id: t.string,
      hidden: t["boolean"]
    })
  }), t.type({
    __typename: t.literal('Error'),
    ErrorMessage: ErrorMessage
  })])
}), t.type({
  id: t.string
}));
export var useEditCommentOnPublic = makeDecodedMutation(gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    mutation EditCommentOnPublicResponse($input: CommentOnPublicResponseInput!) {\n      editCommentOnPublicResponse(input: $input) {\n        ... on CommentOnPublicResponseErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n        ... on CommentOnPublicResponseResult {\n          result {\n            id\n            body\n          }\n        }\n      }\n    }\n  "]))), t.type({
  editCommentOnPublicResponse: t.union([t.type({
    __typename: t.literal('CommentOnPublicResponseResult'),
    result: t.type({
      id: t.string,
      body: t.string
    })
  }), t.type({
    __typename: t.literal('CommentOnPublicResponseErrors'),
    errors: t.array(ErrorMessage)
  })])
}), t.type({
  input: t.type({
    id: t.string,
    body: t.string
  })
}));
export var useDeleteCommentOnPublic = makeDecodedMutation(gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    mutation DeleteCommentOnPublicResponse($input: ID!) {\n      deleteCommentOnPublicResponse(input: $input) {\n        ... on CommentOnPublicResponseErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n        ... on CommentOnPublicResponseResult {\n          result {\n            id\n            body\n          }\n        }\n      }\n    }\n  "]))), t.type({
  deleteCommentOnPublicResponse: t.union([t.type({
    __typename: t.literal('CommentOnPublicResponseResult'),
    result: t.type({
      id: t.string,
      body: t.string
    })
  }), t.type({
    __typename: t.literal('CommentOnPublicResponseErrors'),
    errors: t.array(ErrorMessage)
  })])
}), t.type({
  input: t.string
}));